import script from "./BaseImageElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseImageElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseImageElement.vue?vue&type=style&index=0&id=c874e65e&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c874e65e"]])

export default __exports__